import React from 'react';
export var loggedContext = React.createContext(null);
//# sourceMappingURL=loggedContext.js.map